(function () {
  function waitForCollectionDOM(callback, timeout = 5000) {
    const start = Date.now();
    const timer = setInterval(() => {
      const productGrid = document.getElementById('product-grid');
      const allProductsContainer = document.getElementById('all-products');

      if (productGrid && allProductsContainer) {
        clearInterval(timer);
        callback();
      }

      if (Date.now() - start > timeout) {
        clearInterval(timer);
        console.warn('Collection pagination init timed out');
      }
    }, 50);
  }

  // Main pagination initializer
  window.initCollectionPagination = function () {
    const productGrid = document.getElementById('product-grid');
    const allProductsContainer = document.getElementById('all-products');
    const paginationContainer = document.getElementById('custom-pagination');
    const productCountEl = document.querySelector('.js-product-count');

    if (!productGrid || !allProductsContainer) return;

    const productsPerPage = parseInt(productGrid.dataset.productsPerPage, 10) || 16;

 const allProducts = Array.from(
  allProductsContainer.querySelectorAll('.product-item')  
);
    const totalProducts = allProducts.length;
    const totalPages = Math.ceil(totalProducts / productsPerPage);

    let currentPage = parseInt(new URLSearchParams(window.location.search).get('p'), 10) || 1;

    if (currentPage < 1) currentPage = 1;
    if (currentPage > totalPages) currentPage = totalPages || 1;

    if (productCountEl) {
      productCountEl.textContent = totalProducts;
    }

    function renderProducts(page) {
      currentPage = page;
      productGrid.innerHTML = '';

      const start = (page - 1) * productsPerPage;
      const end = Math.min(start + productsPerPage, totalProducts);

      allProducts.slice(start, end).forEach(productDiv => {
        const li = document.createElement('li');
        li.className = 'flex-grid__item';
        li.innerHTML = productDiv.innerHTML;
        productGrid.appendChild(li);
      });

      renderPagination();

      const url = new URL(window.location.href);
      url.searchParams.set('p', page);
      history.replaceState({}, '', url);

      // Scroll to top of product grid
      productGrid.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }

    function renderPagination() {
      if (!paginationContainer || totalPages <= 1) {
        if (paginationContainer) paginationContainer.innerHTML = '';
        return;
      }

      let html = '<div class="pagination-wrapper">';

      html += `<button class="pagination-btn" ${currentPage === 1 ? 'disabled' : ''} data-page="${currentPage - 1}">
        <span>←</span>
      </button>`;
      const maxVisible = 7;
      if (totalPages <= maxVisible) {
        for (let i = 1; i <= totalPages; i++) {
          html += i === currentPage
            ? `<span class="pagination-number active">${i}</span>`
            : `<button class="pagination-number" data-page="${i}">${i}</button>`;
        }
      } else {
    
        html += currentPage === 1
          ? `<span class="pagination-number active">1</span>`
          : `<button class="pagination-number" data-page="1">1</button>`;

        if (currentPage > 3) {
          html += `<span class="pagination-ellipsis">...</span>`;
        }

        const start = Math.max(2, currentPage - 1);
        const end = Math.min(totalPages - 1, currentPage + 1);

        for (let i = start; i <= end; i++) {
          html += i === currentPage
            ? `<span class="pagination-number active">${i}</span>`
            : `<button class="pagination-number" data-page="${i}">${i}</button>`;
        }

        if (currentPage < totalPages - 2) {
          html += `<span class="pagination-ellipsis">...</span>`;
        }

        html += currentPage === totalPages
          ? `<span class="pagination-number active">${totalPages}</span>`
          : `<button class="pagination-number" data-page="${totalPages}">${totalPages}</button>`;
      }

      html += `<button class="pagination-btn" ${currentPage === totalPages ? 'disabled' : ''} data-page="${currentPage + 1}">
        <span> →</span>
      </button>`;

      html += '</div>';

      paginationContainer.innerHTML = html;

      paginationContainer.querySelectorAll('button').forEach(btn => {
        btn.addEventListener('click', () => {
          const page = parseInt(btn.dataset.page, 10);
          if (!isNaN(page)) renderProducts(page);
        });
      });
    }

    renderProducts(currentPage);
  };

  function setupFacetListener() {
    const facetForm = document.querySelector('facet-filters-form');
    if (!facetForm) return;

    // Create a MutationObserver to watch for DOM changes after facet updates
    const observer = new MutationObserver((mutations) => {
      // Check if the product grid or all-products container was updated
      const hasRelevantChanges = mutations.some(mutation => {
        return Array.from(mutation.addedNodes).some(node => {
          return node.id === 'all-products' || 
                 node.id === 'product-grid' ||
                 (node.querySelector && (
                   node.querySelector('#all-products') || 
                   node.querySelector('#product-grid')
                 ));
        });
      });

      if (hasRelevantChanges) {
        setTimeout(() => {
          window.initCollectionPagination();
        }, 100);
      }
    });

    // Observe the main collection container
    const collectionContainer = document.querySelector('#ProductGridContainer');
    if (collectionContainer) {
      observer.observe(collectionContainer, {
        childList: true,
        subtree: true
      });
    }

    document.addEventListener('facet:updated', () => {
      setTimeout(() => {
        window.initCollectionPagination();
      }, 100);
    });
  }

  document.addEventListener('DOMContentLoaded', () => {
    waitForCollectionDOM(() => {
      window.initCollectionPagination();
      setupFacetListener();
    });
  });

  
  window.addEventListener('popstate', () => {
    waitForCollectionDOM(() => {
      window.initCollectionPagination();
    });
  });
})();